import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates';
import { useFormik } from "formik"
import * as Yup from "yup"
import { FaPen, FaTrash } from 'react-icons/fa'
import axios from 'axios';
import { Url } from '../Url';
import FooterVenta from '../footerVenta';
import SearchAutoComplete from '../searchAutoComplete';


const FormVentas = () => {
    const [cantidad, setCantidad] = useState(1)
    
    const [combo, setCombo] = useState({})
    const [precioUnitario, setPrecioUnitario] = useState('')
    const { producto, setProducto, setProductoAux, productos, setProductos, subProductos, setSubProductos, combos, setCombos, codigo, setCodigo, venta, setVenta, setProductoSelected, setViewOpen, modify, setFormView, precio } = useContext(ContextStates)

    const inputRef = useRef(null);

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify])

    useEffect(() => {
        const getCombos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listCombos.php',
                    method: 'POST',
                    data: formData,
                })
                //console.log(results.data.results)
                setCombos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getCombos()
    }, [modify])

    useEffect(() => {
        const addProducto = async () => {
            if (typeof producto !== 'undefined') {
                if (producto.codigo) {
                    const auxVenta = JSON.stringify(venta)
                    const formData = new FormData()
                    formData.append('venta', auxVenta);
                    formData.append('producto', JSON.stringify(producto));
                    
                    try {
                        const response = await axios({
                            url: Url + 'api/addProducto.php',
                            'Content-Type': 'application/json',
                            method: 'POST',
                            data: formData,
                            dataType: 'JSON',
                        })
                        //console.log(response)
                        setVenta(response.data.results);
                        
                        setProducto({})
                        setCantidad(1)
                        setPrecioUnitario('')
                        setSubProductos([])
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        }
        addProducto()
    }, [producto])

    useEffect(() => {
        const addCombo = async () => {
            if (typeof combo !== 'undefined') {
                if (combo.codigo) {
                    const auxVenta = JSON.stringify(venta)
                    const formData = new FormData()
                    formData.append('venta', auxVenta);
                    formData.append('combo', JSON.stringify(combo));
                    try {
                        const response = await axios({
                            url: Url + 'api/addCombo.php',
                            'Content-Type': 'application/json',
                            method: 'POST',
                            data: formData,
                            dataType: 'JSON',
                        })
                        console.log(response)
                        setVenta(response.data.results);
                        setCombo({})
                        setCantidad(1)
                        setPrecioUnitario('')
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        }
        addCombo()
    }, [combo])

    const formik = useFormik({
        initialValues: {
            codigo: ''
        },
        validationSchema: Yup.object({
            codigo: Yup.string()
        }),
        onSubmit: async (valores, { resetForm }) => {
            if (valores.codigo!=='') {
                setSubProductos([])
    
                let aux = await productos.find(element => element.codigo === valores.codigo);
                if (typeof aux !== 'undefined') {
                    aux.cantidad = cantidad;
                    setProductoAux(aux)
                    if (aux.subproductos.length>0) {
                        console.log("agrega")
                        setSubProductos(aux.subproductos)
                    }
                    setFormView(110)
                    setViewOpen(true)
            
                    /*else
                        setProducto(aux)*/
                }
                else {
                    aux = await combos.find(element => element.codigo === valores.codigo);
                    if (typeof aux !== 'undefined') {
                        aux.cantidad = cantidad;
                        setCombo(aux)
                    }
                }
                resetForm({ values: '' });
                setCodigo('')    
            }
        }
    });

    useEffect(()=>{
        if (codigo!='') {
            formik.setFieldValue("codigo", codigo)
            inputRef.current.focus()
        }
    }, [codigo])
    
    useEffect(() => {
        const checkDatos = () => {
            productos.forEach(element => {
                if (element.codigo === formik.values.codigo) {
                    if (!precio) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            setPrecioUnitario(element.preciopromocion)
                        }
                        else {
                            setPrecioUnitario(element.precio)
                        }
                    }
                    else {
                        setPrecioUnitario(element.preciopormayor)
                    }

                }
            });
        }
        checkDatos()
    }, [formik.values.codigo])

    useEffect(() => {
        const handleSetPrecio = () => {
            if (formik.values.codigo != '') {
                productos.forEach(element => {
                    if (element.codigo === formik.values.codigo) {
                        if (element.idunidad !== '1') {
                            let aux = 0;
                            if (!precio) {
                                if (element.tipopromo === '1' || element.tipopromo === '2') {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.preciopromocion);
                                }
                                else {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.precio);
                                }
                            }
                            else {
                                aux = parseFloat(precioUnitario) / parseFloat(element.preciopormayor);
                            }
                            aux = aux.toFixed(0)
                            setCantidad(aux)
                        }
                    }
                });
            }
        }
        handleSetPrecio()
    }, [precioUnitario])

    const submitCantidad = (event) => {
        event.preventDefault();
        if (cantidad !== '')
            inputRef.current.focus()
    }

    const handleAdd = () => {
        formik.handleSubmit();
        inputRef.current.focus()
    }

    const handleDelete = (item) => {
        let rData = []
        venta.forEach(element => {
            if (element.idlinea !== item.idlinea) {
                rData.push(element)
            }
        });
        setVenta(rData)
    }

    const handleSet = (item) => {
        setProductoSelected(item)
        setFormView(1)
        setViewOpen(true)
    }

    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio);
    }

    return (
        <div className='flex flex-col h-screen justify-between'>
            <div className="transition-all w-full mt-3 flex">
                <div className={`w-full md:w-11/12 lg:w-10/12 mx-auto mt-1 p-3 rounded-lg flex ${!precio ? 'bg-indigo-200' : 'bg-orange-200'} `}>
                    <form
                        className="w-1/4"
                        onSubmit={formik.handleSubmit}
                    >
                        <div className="sm:items-start lg:px-5 sm:px-1">
                            <label htmlFor="codigo" className="block text-gray-600 uppercase font-bold">Código</label>
                            <input
                                type="text"
                                className="py-2 px-3 w-full rounded border border-blue-300"
                                id="codigo"
                                ref={inputRef}
                                placeholder="Código de producto"
                                value={formik.values.codigo}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                autoFocus
                            />
                        </div>
                    </form>
                    <div className="w-1/2 sm:items-start lg:px-5 sm:px-1">
                        <SearchAutoComplete
                            items={productos}
                            mode={0}
                        />
                    </div>
                    <div className="w-1/10 sm:items-start lg:px-5 sm:px-1">
                        <label htmlFor="punitario" className="block text-gray-600 uppercase font-bold">Precio/u</label>
                        <input
                            type="text"
                            className="py-2 px-3 w-full rounded border border-blue-300"
                            id="punitario"
                            value={precioUnitario}
                            onChange={(e) => setPrecioUnitario(e.target.value)}
                        />
                    </div>
                    <div className="w-1/10 sm:items-start lg:px-5 sm:px-1">
                        <form onSubmit={submitCantidad}>
                            <label htmlFor="cantidad" className="block text-gray-600 uppercase font-bold">Cantidad</label>
                            <input
                                type="number"
                                className="py-2 px-3 w-full rounded border border-blue-300"
                                id="cantidad"
                                placeholder="Cantidad"
                                value={cantidad}
                                onChange={(e) => setCantidad(e.target.value)}
                            />
                        </form>
                    </div>
                    <div className="w-1/10 sm:items-start lg:px-5 sm:px-1 pt-4">
                        <input
                            type="button"
                            className="w-full shadow-md p-1 sm:p-3 bg-blue-600 text-gray-100 hover:bg-blue-500 hover:cursor-pointer transition-all uppercase font-semibold rounded mt-3 sm:mt-1"
                            value="Agregar"
                            onClick={() => handleAdd()}
                        />
                    </div>
                </div>
            </div>
            <div className="w-10/12 mx-auto mt-3 mb-20">
                {venta && typeof venta !== 'undefined' && venta.length > 0 && (
                    <table className='table-auto w-full border border-collapse border-gray-300'>
                        <thead>
                            <tr className='border border-collapse border-gray-300 bg-blue-100'>
                                <th className='border border-collapse border-gray-300'>Cantidad</th>
                                <th className='border border-collapse border-gray-300'>Código</th>
                                <th className='border border-collapse border-gray-300'>Descripción</th>
                                <th className='border border-collapse border-gray-300'>Precio</th>
                                <th className='border border-collapse border-gray-300'>Subtotal</th>
                                <th className='border border-collapse border-gray-300'>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {typeof venta !== 'undefined' && venta.map((item, index) => (
                                <tr
                                    key={index}
                                    className={`${index % 2 === 0 ? 'bg-white hover:bg-slate-200' : 'bg-slate-100 hover:bg-slate-200'} ' hover:cursor-pointer border-b border-gray-200 ')`}
                                >
                                    <td className='border border-collapse border-gray-300 px-3 text-center'>{item.cantidad}</td>
                                    <td className='border border-collapse border-gray-300 px-3 text-center'>{item.codigo}</td>
                                    <td className='border border-collapse border-gray-300 px-3'>{item.descripcion}</td>
                                    <td className={`border border-collapse border-gray-300 px-3 text-right ${(item.tipopromo === '1' || item.tipopromo === '2') && 'bg-green-200'}`}>{precio ? Math.round(item.preciopormayor) : (item.tipopromo === '1' || item.tipopromo === '2') ? Math.round(item.preciopromocion) : Math.round(parseFloat(item.precio)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    <td className={`border border-collapse border-gray-300 px-3 text-right ${item.tipopromo === '3' && item.cantidad >= item.cantidadminima && 'bg-green-200'}`}>{precio ? (parseFloat(item.preciopormayor) * parseFloat(item.cantidad)).toFixed(0) : (item.tipopromo === '1' || item.tipopromo === '2') ? (parseFloat(item.preciopromocion) * parseFloat(item.cantidad)).toFixed(0) : item.tipopromo === '3' ? calcTotal(item) : (parseFloat(item.precio) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                    <td className='border border-collapse border-gray-300 px-3 text-center'>
                                        <button
                                            className='bg-gray-400 p-3 rounded-md text-white ml-3'
                                            onClick={() => handleSet(item)}
                                        >
                                            <FaPen />
                                        </button>
                                        <button
                                            className='bg-red-400 p-3 rounded-md text-white ml-3'
                                            onClick={() => handleDelete(item)}
                                        >
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>

                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            <FooterVenta />
        </div>
    )
}

export default FormVentas